/**
 * What a term of art means, in one place.
 *
 * WHY THIS IS NOT WRITTEN AT THE CALL SITE. The same term appears on both
 * platforms -- read here by Field's `help` prop, and on mobile by
 * TermHelp -- and two explanations of one word is worse than none:
 * somebody who reads both learns that the app is unsure.
 *
 * It is the same argument services/inspection.py makes about due-ness and
 * accountGrouping makes about whose hive is whose. One place decides;
 * everything else asks.
 *
 * THIS FILE AND ITS MOBILE TWIN MUST AGREE, and they are registered as a
 * pair in platformParity.test.js so losing one half fails rather than
 * quietly leaving one platform explaining a word the other does not.
 * They are copies rather than a shared package because the two apps have
 * no shared build -- which is a real limitation, and the registry is what
 * makes it a visible one.
 *
 * WHAT BELONGS HERE: a term the app uses BECAUSE IT IS THE RIGHT WORD,
 * which a new keeper will not know. Not every field needs an entry -- a
 * "?" on an obvious one is noise, and a file of them would stop being
 * read.
 */

export const TERMS = {
  /*
   * The one that prompted the file. It is on the product label, it
   * decides when honey may legally be sold, and the regulatory treatment
   * report prints it -- so the phrase has to match the bottle, and the
   * explanation has to say what is at stake rather than paraphrasing the
   * words.
   */
  withdrawalPeriod:
    "How long you must wait after treating before taking honey from the hive. "
    + "It is on the treatment's label — and it goes on your treatment report, "
    + "so it is worth checking rather than guessing. Enter 0 if the product "
    + "has none.",
};
